import { useEffect, useState } from "react";
import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { Calendar, User } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/cms/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Journal</div>
          <h1 className="font-display text-5xl lg:text-6xl mt-3">Ideas on money, done well.</h1>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Card key={p.id} className="rounded-3xl overflow-hidden card-hover" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[16/10] bg-muted overflow-hidden">
                <img alt={p.title} src={p.cover} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1"><User className="h-3 w-3" />{p.author}</span>
                  <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" />{new Date(p.created_at).toLocaleDateString()}</span>
                </div>
                <div className="font-display text-xl">{p.title}</div>
                <div className="text-sm text-muted-foreground">{p.excerpt}</div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
